// extracted by mini-css-extract-plugin
export default {"search":"Search_search__I504a","icon":"Search_icon__wEpbO"};